module.exports = "<header class=\"secondary\"></header>\n\n<section class=\"mainless\">\n  <header><h1>Composer Web Technical Preview</h1></header>\n  <section>\n    <p>This software is under active development and is current considered pre-alpha quality.  It must not be used for any purpose with production systems.</p>\n  </section>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome/welcome.component.html
// module id = 1672
// module chunks = 0